
export default {
  breadcrumbs: {
    'user-list': 'Administração - Usuário',
    'user-form': 'Administração - Usuário',
    'client-list': 'Administração - Cliente',
    'client-form': 'Administração - Cliente',
    'cycle-list': 'Administração - Ciclo',
    'cycle-form': 'Administração - Ciclo',
    profile: 'Perfil',
    dashboard: 'Dashboard',
    audit: 'Administração - Auditoria',
    mail: 'Administração - Envio de e-mail',
    'project-list': 'Administração - Projetos',
    'project-form': 'Administração - Projetos',
    'dinamic-query': 'Administração - Consultas Dinâmicas',
    'not-authorized': 'Acesso Negado',
    'called-list': 'Lista de Chamados',
    'called-form': 'Formulário de Chamados',
    'follow-called': 'Acompanhamento de Chamado',
    'event-list': 'Lista de Eventos',
    'event-form': 'Formulário de Eventos',
    'cycle-consolidated': 'Relatório Consolidado de Ciclos',
    'table-manager-list': 'Administração - Gerenciador de Tabelas',
    'table-manager-form': 'Administração - Gerenciador de Tabelas',
    'settings-list': 'Configurações',
    'billing-report-list': 'Administração - Relatório de Faturamento',
    'billing-report-form': 'Administração - Relatório de Faturamento',
    'zoho-report-credential-list': 'Zoho Analytics - Credenciais Zoho Analytics',
    'zoho-report-credential-form': 'Zoho Analytics - Credenciais Zoho Analytics',
    'zoho-report-group-list': 'Zoho Analytics - Grupos de Relatórios',
    'zoho-report-group-form': 'Zoho Analytics - Grupos de Relatórios',
    'zoho-report-view': 'Zoho Analytics - Visualizar Relatório',
    'user-project-list': 'Usuários vinculados a projetos',
    'user-project-form': 'Vincular usuários a projetos',
    'load-conf-list': 'Administração - Configuração de Carga',
    'load-conf-form': 'Administração - Configuração de Carga',
  },
  titles: {
    dashboard: 'Página inicial',
    mailSend: 'Enviar e-mail',
    taskList: 'Lista de Tarefas',
    auditList: 'Lista de Logs',
    register: 'Formulário de Cadastro',
    resetPassword: 'Redefinir Senha',
    update: 'Formulário de Atualização',
    list: 'Listagem',
    attention: 'Atenção',
    userList: 'Lista de Usuários',
    clientList: 'Lista de Clientes',
  },
  actions: {
    send: 'Enviar',
    save: 'Salvar',
    clear: 'Limpar',
    clearAll: 'Limpar Tudo',
    restart: 'Reiniciar',
    filter: 'Filtrar',
    search: 'Pesquisar',
    list: 'Listar',
    edit: 'Editar',
    cancel: 'Cancelar',
    update: 'Atualizar',
    remove: 'Remover',
    getOut: 'Sair',
    add: 'Adicionar',
    in: 'Entrar',
    loadImage: 'Carregar Imagem',
  },
  fields: {
    date: 'Data',
    action: 'Ação',
    actions: 'Ações',
    audit: {
      dateStart: 'Data Inicial',
      dateEnd: 'Data Final',
      resource: 'Recurso',
      allResources: 'Todos Recursos',
      type: {
        created: 'Cadastrado',
        updated: 'Atualizado',
        deleted: 'Removido',
      },
    },
    login: {
      resetPassword: 'Esqueci minha senha',
      confirmPassword: 'Confirmar senha',
    },
    mail: {
      to: 'Para',
      subject: 'Assunto',
      message: 'Mensagem',
    },
    queryDinamic: {
      filters: 'Filtros',
      results: 'Resultados',
      model: 'Model',
      attribute: 'Atributo',
      operator: 'Operador',
      resource: 'Recurso',
      value: 'Valor',
      operators: {
        equals: 'Igual',
        diferent: 'Diferente',
        conteins: 'Contém',
        startWith: 'Inicia com',
        finishWith: 'Finaliza com',
        biggerThan: 'Maior',
        equalsOrBiggerThan: 'Maior ou Igual',
        lessThan: 'Menor',
        equalsOrLessThan: 'Menor ou Igual',
      },
    },
    project: {
      name: 'Nome',
      totalTask: 'Total de Tarefas',
      cost: 'Custo',
    },
    task: {
      done: 'Não Feito / Feito',
    },
    user: {
      perfils: 'Perfis',
      nameOrEmail: 'Nome ou Email',
    },
    cycle: {
      start_date: 'Data de Início',
      end_date: 'Data do Fim',
      client: 'Cliente',
      note: 'Observação',
      name: 'Nome',
    },
    called: {
      description: 'Descrição',
      date: 'Data',
    },
    event: {
      date: 'Data do Evento',
    },
  },
  layout: {
    menu: {
      dashboard: 'Dashboard',
      'project-list': 'Projetos',
      admin: 'Administração',
      examples: 'Exemplos',
      'user-list': 'Usuários',
      'client-list': 'Clientes',
      'cycle-list': 'Ciclos',
      mail: 'Enviar e-mail',
      audit: 'Auditoria',
      dinamicQuery: 'Consultas Dinamicas',
      'called-list': 'Chamados',
      'event-list': 'Eventos',
      reports: 'Relatórios',
      'cycle-consolidated': 'Consolidado de Ciclos',
      'table-manager-list': 'Gerenciador de Tabelas',
      'settings-list': 'Configurações',
      'billing-report-list': 'Relatório de Faturamento',
      'zoho-reports': 'Zoho Analytics',
      'zoho-report-credential-list': 'Credenciais Zoho Analytics',
      'zoho-report-group-list': 'Grupos de Relatórios',
      'zoho-report-view': 'Visualizar Relatório',
      'user-project-list': 'Vincular Usuários - Projetos',
      'load-conf-list': 'Configuração de Carga',
    },
  },
  tooltips: {
    audit: {
      viewDetail: 'Visualizar Detalhamento',
    },
    user: {
      perfil: 'Perfil',
      transfer: 'Transferir',
    },
    task: {
      listTask: 'Listar Tarefas',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/pt-BR/Views.js